import Preview from './preview.js'

class PageHome {

    static init() {
        let el = document.querySelector('.home-container')
        if (!el)
            return

        PageHome.infinite = new InfiniteScroll('.recent-container', {
            path: '.home-load-more',
            append: '.home-recent-col',
            prefill: true,
            elementScroll: '.home-container',
            history: false,
            button: '.home-load-more',
            status: '.home-load-status',
            hideNav: '.home-loader'
        })

        PageHome.infinite.on('append', (a,b,items) => {
            if (!items.length)
                return

            items.forEach(col => {
                let vid = col.querySelector('.movie-thumb-preview')
                if (vid) {
                    vid.preview = new Preview(vid)
                    vid.preview.init()
                }
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', e => {
    PageHome.init()
})

export default PageHome
